import * as React from "react"

export default function Sup(props) {
  return <sup className="text-xxs">{props.children}</sup>
}
